// ** Redux Imports
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// ** Axios Imports
import axios from "axios";

export const setLoading = createAsyncThunk("advanceSettings/setLoading", async (loadingState) => ({ ...loadingState }));

export const getData = createAsyncThunk("advanceSettings/getData", async (params, { dispatch }) => {
   dispatch(setLoading({ getData: true }));
   const response = await axios.get("/Settings/SelectOrganizationAdvancedSettings", { params });

   dispatch(setLoading({ getData: false }));
   return {
      params,
      data: response.data,
   };
});

export const getApprovalData = createAsyncThunk("advanceSettings/getApprovalData", async (params, { dispatch }) => {
   dispatch(setLoading({ getData: true }));
   const response = await axios.get("/Settings/SelectOrganizationApprovalWorkFlowSettingsDetails", { params });

   dispatch(setLoading({ getData: false }));
   return {
      params,
      data: response.data,
   };
});

export const advanceSettings = createSlice({
   name: "advanceSettings",
   initialState: {
      data: {},
      approval_data: {},
      params: {},
      approval_params: {},
      loadingState: { getData: false, getCodeCustomization: false },
      // allData: []
   },
   reducers: {},
   extraReducers: (builder) => {
      builder
         .addCase(getData.fulfilled, (state, action) => {
            state.data = action.payload.data.data;
            state.params = action.payload.params;
         })
         .addCase(getApprovalData.fulfilled, (state, action) => {
            state.approval_data = action.payload.data.data;
            state.approval_params = action.payload.params;
         })
         .addCase(setLoading.fulfilled, (state, action) => {
            state.loadingState = action.payload;
         });
   },
});

export default advanceSettings.reducer;
